import { Box } from '@mui/material';
import { CSSProperties } from 'react';

import { ESeverity } from '#shared';

import { getAircraftTimeSeverity } from '../../helpers';
import { AVAILABILITY_CARD_MAX_HEIGHT } from '../model';

import { CrewAvailabilityCard } from './AircraftCard';

import type { AircraftData } from '#entities';

type Props = {
  data: AircraftData;
  width: number | string;
  fullSize?: boolean;
  onClickId?: (aircraft: AircraftData) => void;
  stretch?: boolean;
};

const headerTextMap: Record<Exclude<ESeverity, ESeverity.MINOR>, string> = {
  [ESeverity.NA]: 'N/A',
  [ESeverity.CRITICAL]: '<4h',
  [ESeverity.MAJOR]: '4-8h',
  [ESeverity.LOW]: '8+h',
};

export const AircraftCardAdapter = ({
  data,
  width,
  fullSize = false,
  onClickId,
  stretch,
}: Props) => {
  const sev = getAircraftTimeSeverity(data) as ESeverity;
  const availabilityGroupName = headerTextMap[sev];

  return (
    <Box
      sx={{
        width,
        height: '100%',
        maxHeight: AVAILABILITY_CARD_MAX_HEIGHT,
        boxSizing: 'border-box',
        '& *': { boxSizing: 'border-box' },
      }}
      onClick={() => onClickId?.(data)}
      style={
        {
          ['--card-w']: `${width}px`,
        } as CSSProperties
      }
    >
      <CrewAvailabilityCard
        aircraftData={data}
        availabilityGroupName={availabilityGroupName}
        fullSize={fullSize}
        stretch={stretch}
      />
    </Box>
  );
};
